const MIN_BIRTH_YEAR = 1924;

export function formatDateOfBirthDisplay(iso: string): string {
  const date = parseIsoDate(iso);
  if (!date) return "";
  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
}

export function parseIsoDate(iso: string): Date | null {
  if (!iso) return null;
  const [year, month, day] = iso.split("-").map((part) => Number.parseInt(part, 10));
  if (!year || !month || !day) return null;
  const date = new Date(year, month - 1, day);
  if (
    Number.isNaN(date.getTime()) ||
    date.getFullYear() !== year ||
    date.getMonth() !== month - 1 ||
    date.getDate() !== day
  ) {
    return null;
  }
  return date;
}

export function partsFromDateOfBirth(iso: string): { month: string; day: string; year: string } {
  const date = parseIsoDate(iso);
  if (!date) return { month: "", day: "", year: "" };
  return {
    month: String(date.getMonth() + 1).padStart(2, "0"),
    day: String(date.getDate()).padStart(2, "0"),
    year: String(date.getFullYear()),
  };
}

export function isValidDateOfBirthParts(month: number, day: number, year: number): boolean {
  const today = new Date();
  const maxYear = today.getFullYear();
  if (year < MIN_BIRTH_YEAR || year > maxYear) return false;
  if (month < 1 || month > 12 || day < 1 || day > 31) return false;

  const date = new Date(year, month - 1, day);
  if (
    date.getFullYear() !== year ||
    date.getMonth() !== month - 1 ||
    date.getDate() !== day
  ) {
    return false;
  }

  return date <= today;
}

export function toDateOfBirthIso(month: number, day: number, year: number): string | null {
  if (!isValidDateOfBirthParts(month, day, year)) return null;
  return `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
}
